import {makeGetProvidersDetailsDentalGuide} from 'main/factories/usecases';
import {OdontoProviderDetailsParams} from './types';

export async function getOdontoProviderDetails(params: OdontoProviderDetailsParams) {
	const response = await makeGetProvidersDetailsDentalGuide().get(params);
	return response?.detalhamento;
}
